// Multicolour Google "G" logo, sized to match icon buttons
export default function GoogleIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.9-5.5 3.9-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.4 14.7 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z" />
      <path fill="#34A853" d="M3.9 7.4l3.2 2.4C7.9 8 9.8 6.7 12 6.7c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.4 14.7 2.4 12 2.4 8.4 2.4 5.3 4.4 3.9 7.4z" />
      <path fill="#FBBC05" d="M12 21.6c2.6 0 4.8-.9 6.4-2.3l-2.9-2.4c-.8.5-1.9.9-3.5.9-2.7 0-5-1.8-5.8-4.3L3 15.8c1.4 3.4 4.9 5.8 9 5.8z" />
      <path fill="#4285F4" d="M21.4 12.2c0-.6-.1-1.1-.2-1.6H12v3.9h5.5c-.2 1.3-1 2.4-2.1 3.1l2.9 2.4c1.7-1.5 3.1-3.9 3.1-7.8z" />
    </svg>
  );
}
